(()=>{
const MONEY_FIELDS = {
  weekly: [0, 1000],
  price: [0, 100000],
  extras: [0, 100000],
  monthly: [0, 10000],
};

function formNumber(value) {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string' || value.trim() === '') return NaN;
  if (!/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim())) return NaN;
  return Number(value);
}

function cents(value) {
  return Math.round((value + Number.EPSILON) * 100);
}

/**
 * Compare replaced memberships with one shared home setup.
 * Inputs and totals use whole cents; split is rounded to cents. Weekly cost is
 * an unrounded per-adult rate, for the UI to format without changing the total.
 * `monthly` is the whole household's home cost, never a per-person cost.
 */
function estimateHousehold(values) {
  const input = values && typeof values === 'object' ? values : {};
  const numbers = {};
  const invalid = [];
  const people = formNumber(input.people);
  const years = formNumber(input.years);
  const basis = input.basis;

  if (!Number.isInteger(people) || people < 1 || people > 8) invalid.push('people');
  if (basis !== 'individual' && basis !== 'household') invalid.push('basis');
  for (const key of ['weekly', 'years', 'price', 'extras', 'monthly']) {
    if (key === 'years') {
      if (!Number.isInteger(years) || years < 1 || years > 10) invalid.push(key);
      continue;
    }
    const number = formNumber(input[key]);
    const [minimum, maximum] = MONEY_FIELDS[key];
    if (!Number.isFinite(number) || number < minimum || number > maximum ||
        (key === 'price' && (number <= 0 || cents(number) === 0))) {
      invalid.push(key);
    } else {
      numbers[key] = cents(number);
    }
  }
  if (invalid.length) return { valid: false, invalid };

  const multiplier = basis === 'individual' ? people : 1;
  const annualGymCents = numbers.weekly * 52 * multiplier;
  const gymCents = annualGymCents * years;
  const upfrontCents = numbers.price + numbers.extras;
  const homeCents = upfrontCents + numbers.monthly * 12 * years;
  const annualAvoidedCents = annualGymCents - numbers.monthly * 12;

  return {
    valid: true,
    people,
    basis,
    years,
    gym: gymCents / 100,
    home: homeCents / 100,
    saving: (gymCents - homeCents) / 100,
    upfront: upfrontCents / 100,
    split: Math.round(upfrontCents / people) / 100,
    perWeekPerAdult: homeCents / (52 * years * people) / 100,
    breakEven: annualAvoidedCents > 0 ? upfrontCents * 12 / annualAvoidedCents : null,
  };
}


const root=document.querySelector('.cf[data-audience="couples-families"]');
if(root){
 const $=s=>root.querySelector(s);
 const form=$('#cf-cost-form');
 const fields=Array.from(form.querySelectorAll('[name]'));
 const result=$('.cf-result');
 let priceState='loading';
 let currency='GBP';
 let lastEstimate=null;
 let lastPriceEach=null;
 let lastSaveAmount=0;
 const presets={two:{people:'2',basis:'individual',weekly:'11'},three:{people:'3',basis:'individual',weekly:'11'}};
 const money=(value,decimals=0)=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:decimals,maximumFractionDigits:decimals}).format(value);
 function updateSticky(){
  const offer=$('#cf-sticky-offer');
  if(!offer)return;
  if(priceState==='ready'&&lastPriceEach!=null){
   offer.innerHTML=lastSaveAmount>0
    ?`GM3 Studio ${money(lastPriceEach,0)} · <span class="cf-nowrap">Save ${money(lastSaveAmount,0)}</span>`
    :`GM3 Studio ${money(lastPriceEach,0)}`;
  }else{
   offer.textContent='Shop Gym Monster 3 Studio';
  }
 }
 function render(){
  const values=Object.fromEntries(fields.map(f=>[f.name,f.value]));
  const estimate=estimateHousehold(values);
  lastEstimate=estimate;
  root.querySelectorAll('[data-preset]').forEach(b=>{const p=presets[b.dataset.preset];b.setAttribute('aria-pressed',String(p.people===values.people&&p.basis===values.basis&&Number(p.weekly)===Number(values.weekly)&&values.weekly!==''));});
  root.querySelectorAll('[data-years]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.years)===Number(values.years)&&values.years!=='')));
  $('#cf-weekly-label').textContent=values.basis==='household'?'Weekly household cost (GBP)':'Weekly cost per adult (GBP)';
  fields.forEach(f=>{if(f.type!=='hidden')f.setAttribute('aria-invalid',String(!estimate.valid&&estimate.invalid.includes(f.name)));});
  const invalidInputs=!estimate.valid&&estimate.invalid.some(k=>k!=='price');
  $('#cf-cost-error').hidden=!invalidInputs;
  const unavailable=priceState==='unavailable';
  const setupLink=$('#cf-calc-setup');
  if(setupLink){
   setupLink.href=unavailable?$('#cf-product-link').href:'#cf-setup';
   setupLink.innerHTML=unavailable?'Check current packages <span aria-hidden="true">↗</span>':'See what’s included <span aria-hidden="true">↓</span>';
  }
  const resultBuy=$('#cf-result-buy-link');
  if(!estimate.valid){
   result.dataset.state=priceState==='loading'&&!invalidInputs?'loading':'error';
   $('#cf-result-label').textContent=Number(values.people)===1?'You pay':'You each pay';
   $('#cf-result-value').textContent=invalidInputs?'Check your details':priceState==='loading'?'Checking price…':'Check current price';
   $('#cf-result-period').textContent=invalidInputs?'Use zero for costs you will not pay. Adults must be 1 to 8 and years 1 to 10.':priceState==='loading'?'Using the current Gym Monster 3 / Studio price.':'Current Studio pricing is unavailable. See the product page for current packages.';
   $('#cf-gym-total').textContent='Pending';$('#cf-home-total').textContent='Pending';
   $('#cf-result-saving').textContent='';
   $('#cf-break-even').textContent='';
   $('#cf-gym-bar').style.transform='scaleX(0)';$('#cf-home-bar').style.transform='scaleX(0)';
   if(resultBuy)resultBuy.hidden=true;
   updateSticky();
   return;
  }
  const r=estimate;
  if(resultBuy)resultBuy.hidden=false;
  result.dataset.state=r.saving>0?'positive':r.saving<0?'negative':'equal';
  $('#cf-result-label').textContent=r.people===1?'You pay':'You each pay';
  $('#cf-result-value').textContent=money(r.perWeekPerAdult,2);
  $('#cf-result-period').textContent=r.people===1
   ?`a week, over ${r.years} ${r.years===1?'year':'years'}.`
   :`a week, split ${r.people} ways over ${r.years} ${r.years===1?'year':'years'}.`;
  $('#cf-gym-label').textContent=r.basis==='household'?'One household gym plan':`${r.people} gym ${r.people===1?'membership':'memberships'}`;
  $('#cf-gym-total').textContent=money(r.gym,0);
  $('#cf-home-total').textContent=money(r.home,0);
  const max=Math.max(r.gym,r.home,1);
  $('#cf-gym-bar').style.transform=`scaleX(${r.gym/max})`;
  $('#cf-home-bar').style.transform=`scaleX(${r.home/max})`;
  const monthlyOngoing=formNumber(values.monthly)||0;
  $('#cf-result-saving').textContent=r.saving>0
   ?`${money(r.saving,0)} stays in your household over ${r.years} ${r.years===1?'year':'years'}.`
   :r.saving<0
   ?`Your example gym cost is ${money(r.gym,0)} over ${r.years} ${r.years===1?'year':'years'}. Your home setup totals ${money(r.home,0)}, and it's yours after that.`
   :'Even cost in this example, and the machine stays yours.';
  $('#cf-break-even').textContent=r.breakEven===null?'':monthlyOngoing>0
   ?`Paid off in ${Math.ceil(r.breakEven)} months, after your ongoing home costs.`
   :`Paid off in ${Math.ceil(r.breakEven)} months. After that, every session is free.`;
  updateSticky();
 }
 fields.forEach(f=>f.addEventListener('input',render));
 form.addEventListener('submit',e=>e.preventDefault());
 root.querySelectorAll('[data-preset]').forEach(b=>b.addEventListener('click',()=>{Object.entries(presets[b.dataset.preset]).forEach(([key,value])=>form.elements[key].value=value);render();}));
 root.querySelectorAll('[data-years]').forEach(b=>b.addEventListener('click',()=>{form.elements.years.value=b.dataset.years;render();}));
 render();

 const features={
  own:{image:'guided-workout',title:'A routine that belongs to you.',body:'Keep your workouts and progress personal with your own account. Follow guided sessions or build your own workout, then let the next person choose theirs.',note:'Unlimited user accounts. Everyone keeps their own programme and history.',alt:'A woman choosing a workout on Gym Monster 3’s touchscreen'},
  weight:{image:'digital-weights',title:'Their weights don’t have to be yours.',body:'Change the digital resistance between sets without loading weight plates. Each adult can choose the resistance and movements that suit their own session.',note:'Up to 100 kg of digital resistance, in 1 kg steps.',alt:'A woman adjusting digital resistance on the Gym Monster 3 touchscreen'},
  together:{image:'shared-training',title:'Some sessions are better together.',body:'Take turns on your own schedule, or explore supported Partner Mode exercises together. A little shared training time, without having to share every goal.',note:'Partner Mode workouts are built for two.',alt:'Two adults training together on opposite sides of Gym Monster 3'}
 };
 const manifestNode=$('#cf-feature-assets');
 const manifest=manifestNode?JSON.parse(manifestNode.textContent):null;
 const initialImage=$('#cf-feature-image').src;
 const mediaUrl=(name,size)=>manifest?manifest[name][size]:new URL(`${name}-${size}.webp`,initialImage).href;
 const tabs=Array.from(root.querySelectorAll('[data-feature]'));
 function chooseFeature(tab,focus=false){
  const feature=features[tab.dataset.feature];
  tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
  $('#cf-feature-panel').setAttribute('aria-labelledby',tab.id);
  const img=$('#cf-feature-image');img.src=mediaUrl(feature.image,1680);img.srcset=`${mediaUrl(feature.image,840)} 840w, ${mediaUrl(feature.image,1680)} 1680w`;img.alt=feature.alt;
  $('#cf-feature-title').textContent=feature.title;$('#cf-feature-body').textContent=feature.body;$('#cf-feature-note').textContent=feature.note;
  if(focus)tab.focus();
 }
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>chooseFeature(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();chooseFeature(tabs[next],true);}});});

 const isLocal=['localhost','127.0.0.1'].includes(location.hostname);
 const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
 const endpoint=isLocal?'/api/product/gm3':`${window.Shopify?.routes?.root||'/'}products/speediance-gym-monster-3.js`;
 fetch(endpoint,{signal:controller.signal}).then(response=>{if(!response.ok)throw new Error('Catalogue unavailable');return response.json();}).then(product=>{
  const variant=(product.variants||[]).find(v=>v.available&&Number(v.price)>0&&(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
  if(!variant)throw new Error('Studio unavailable');
  const catalogueCurrency=product.currency||window.Shopify?.currency?.active;
  if(catalogueCurrency!=='GBP')throw new Error('Currency mismatch');
  currency=catalogueCurrency;
  const priceEach=Number(variant.price)/100;
  const wasEach=variant.compare_at_price&&Number(variant.compare_at_price)/100;
  const onSale=wasEach&&wasEach>priceEach;
  form.elements.price.value=priceEach;priceState='ready';
  lastPriceEach=priceEach;lastSaveAmount=onSale?wasEach-priceEach:0;
  const productUrl=(isLocal?'https://speediance.com.au':location.origin)+(window.Shopify?.routes?.root||'/')+`products/speediance-gym-monster-3?variant=${encodeURIComponent(variant.id)}`;
  $('#cf-price').textContent=money(priceEach,0);
  $('#cf-price-was').textContent=onSale?money(wasEach,0):'';
  $('#cf-price-save').textContent=onSale?`Save ${money(wasEach-priceEach,0)}`:'';
  $('#cf-product-link').href=productUrl;
  const payOverTime=$('#cf-pay-over-time');if(payOverTime)payOverTime.href=productUrl;
  const heroBuy=$('#cf-hero-buy');if(heroBuy)heroBuy.href=productUrl;
  const heroSave=$('#cf-hero-save');if(heroSave)heroSave.textContent=onSale?`, save ${money(wasEach-priceEach,0)}`:'';
  const heroPriceClause=$('#cf-hero-price-clause');const heroPriceEach=$('#cf-hero-price-each');
  if(heroPriceClause&&heroPriceEach){heroPriceEach.textContent=money(priceEach/(2*5*52),2);heroPriceClause.hidden=false;}
  const faqPrice=$('#cf-faq-price');if(faqPrice)faqPrice.textContent=`${money(priceEach,0)}, once`;
  const resultPrice=$('#cf-result-price');if(resultPrice)resultPrice.textContent=money(priceEach,0);
  const resultWas=$('#cf-result-price-was');if(resultWas)resultWas.textContent=onSale?money(wasEach,0):'';
  const resultSave=$('#cf-result-price-save');if(resultSave)resultSave.textContent=onSale?`Save ${money(wasEach-priceEach,0)}`:'';
  const resultBuyLink=$('#cf-result-buy-link');if(resultBuyLink)resultBuyLink.href=productUrl;
  const stickyBuy=$('#cf-sticky-buy');if(stickyBuy)stickyBuy.href=productUrl;
 }).catch(()=>{
  priceState='unavailable';form.elements.price.value='';
  $('#cf-price').textContent='Check Studio package availability';
  $('#cf-price-was').textContent='';$('#cf-price-save').textContent='';
  const heroSave=$('#cf-hero-save');if(heroSave)heroSave.textContent='';
  const resultPrice=$('#cf-result-price');if(resultPrice)resultPrice.textContent='Check current price';
  const resultWas=$('#cf-result-price-was');if(resultWas)resultWas.textContent='';
  const resultSave=$('#cf-result-price-save');if(resultSave)resultSave.textContent='';
 }).finally(()=>{clearTimeout(timer);render();});

 const action=$('.cf-mobile-action');const visible=new Map();
 const heroEl=$('.cf-hero');
 const heroBuyEl=$('#cf-hero-buy');
 if('IntersectionObserver' in window){
  const watched=[heroBuyEl,$('.cf-result-buy'),$('.cf-product-copy .cf-actions'),$('.cf-close'),document.querySelector('footer')].filter(Boolean);
  const observer=new IntersectionObserver(entries=>{
   entries.forEach(e=>visible.set(e.target,e.isIntersecting));
   const anyCtaVisible=Array.from(visible.values()).some(Boolean);
   action.hidden=anyCtaVisible;
   root.classList.toggle('cf-cta-in-view',anyCtaVisible);
  },{threshold:.05});
  watched.forEach(e=>observer.observe(e));
  if(heroEl){
   const heroObserver=new IntersectionObserver(entries=>{
    entries.forEach(e=>root.classList.toggle('cf-hero-in-view',e.isIntersecting));
   },{threshold:.05});
   heroObserver.observe(heroEl);
  }
 }
}


})();
